import React from 'react';

const AddPartsModal = ({
  show,
  title,
  fields,
  renderField,
  onCancel,
  onSave,
}) => {
  if (!show) return null;

  return (
    <div className="modal modal-backdrop show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onCancel} />
          </div>
          <div className="modal-body">
            <div className="row g-3">{fields.map(renderField)}</div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={onSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPartsModal;
